import {
  ENGLISH_LANGUAGE_CODE_TYPE,
  SPANISH_LANGUAGE_CODE_TYPE,
} from "../constants/locale";

export interface LearningMetaData {
  title: string;
  format: string;
  contentMetaLang: string;
  contentMetaId: string;
  length: number;
  fullHtml: string;
  summary: string;
  clinicianTitle: string;
  clinicianSummary: string;
  vtt: string;
  videoUrl: string;
  thumbnail: string;
  isSuccess: boolean;
  httpErrorCode: number;
  errorMessage: string;
}
export interface ActivityData {
  activityId: number;
  activityDisplayName: string;
  activityCompletionStatus: string;
  activityCompletionStatusCode: string;
  activityCalculatedStatus: string;
  activityIconPath: string;
  activityPoints: number;
  activityType: string;
  contentTypeCode: string;
  contentCode: string;
  activityCategoryName: string;
  activitySubCategoryName: string;
  casePlanMilestoneMappingId: string;
  milestoneLearningUrls: string;
  learningMetaData?: LearningMetaData;
  educationalContentSourceId?: number;
  updatedDateTime: string;
  activityShortDescription: string;
}

export interface TrimesterPlan {
  week: string;
  trimester: string;
  status: string;
  points: number;
  progress: number;
  weekUpdate: string;
  weekType: string;
  displayGroupId: number;
  activities: ActivityData[];
  groupProgressStatus: string;
  displayGroupDisplayName: string;
  accumulatedPointsByGroup: number;
  headerTextUnderGroup: string;
  groupImagePath: string;
  imageText: string;
  groupCompletionPercentage: number;
  groupProgressStatusCode: string;
}

export interface TrimesterComponentProps {
  trimesterDisplayName: string;
  trimesterPlans: TrimesterPlan[];
  expandAll: boolean;
}

export interface Trimester {
  trimesterDisplayName: string;
  trimesterNumber: number;
  trimesterPlans: TrimesterPlan[];
  trimesterCurrentStatus: boolean;
}

export interface CarePlan {
  patientPlansInfo: Trimester[];
}

export interface StatusColor {
  key: string;
  value: string;
}

// Backend Response Types
export interface BackendActivity {
  activityDisplayName: string;
  activityCompletionStatus: string;
  activityPoints: number;
}

export interface BackendGroup {
  displayGroupDisplayName: string;
  accumulatedPointsByGroup: number;
  activities: BackendActivity[];
  weekType: string; // "Past, "Current", "Future"
}

export interface BackendTrimester {
  trimesterDisplayName: string;
  trimesterPlans: BackendGroup[];
  trimesterCurrentStatus: boolean;
}

export interface BackendResponse {
  patientPlansInfo: BackendTrimester[];
}

// Formatted Data Types
export type LanguageCode =
  | ENGLISH_LANGUAGE_CODE_TYPE
  | SPANISH_LANGUAGE_CODE_TYPE;

export type TaskStatus = "Completed" | "Not Completed" | "Pending";
export const DraggableItemTypes = {
  CARD: "card",
};

export interface Task {
  name: string;
  status: TaskStatus;
  points: number;
}

export interface TaskGroup {
  groupName: string;
  points: number;
  weekType: string; // "Past, "Current", "Future"
  tasks: Task[];
}

export interface TrimesterData {
  trimesterDisplayName: string;
  points: number;
  trimesterCurrentStatus: boolean;
  taskGroups: TaskGroup[];
}

export interface DragDropCardList {
  appModuleId: number;
  appModuleDisplayName: string;
  appModuleCode: string;
  title: string;
  description: string;
  displaySequence: number;
  isActive: boolean;
}

export interface Reasons {
  categoryCode: string;
  categoryDisplayName: string;
  categoryId: number;
  displayReason: string;
  reasonId: number;
  reasonCode: string;
}

export interface KeyValue {
  label: string;
  value: boolean;
}

export interface Celebrations {
  content: string;
  imageUrl: string;
  sequence: number;
  visualCelebrationId: string;
  eventCode: string;
}

export type BackgroundVariant =
  | "welcomeOverviewDesktop"
  | "welcomeOverviewMobile"
  | "welcomeCoverGreenDesktop"
  | "welcomeCoverGreenMobile"
  | "carePlanPageDesktop"
  | "carePlanPageMobile"
  | "babyWeekImageDesktop"
  | "babyWeekImageMobile"
  | "learningImageDesktop"
  | "learningImageMobile"
  | "learningCategoryImageDesktop"
  | "learningCategoryImageMobile"
  | "default";
